/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import * as Sentry from "@sentry/react";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading/NewHeading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import GenericTable from "./MemberSearch/Components/GenericTable";
import { SERVICES } from "../../components/Layout/Services";
import { SERVICES as MasterDataServices } from "../../components/Layout/Services/MasterDataServices";
import { get, put } from "../../components/Layout/ApiHandler/apihandler";
import AutoCompleteDropdown from "../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../components/Layout/fieldInput/InputField";
import Button from "../../components/Layout/Button/index";
import BasicDatePicker from "../../components/DatePicker/BasicDatePickerV2";
import Loader from "../../components/Loader/Loader";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";

const DEFAULT_PAGE_SIZE = 5;
const tableHeaders = [
  "Mode of Payment",
  "Amount",
  "Contrubution Date",
  "payment Status",
  "Uin Types",
];
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
const getOptionsForUin = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    label: opt[key].replace(/_/g, " "),
    value: opt[key],
  }));
const UPDATE_FIELDS = {
  UPDATE_MEMBER_NAME: "fullName",
};
function MemberContributionUpdate() {
  const { memberId } = useParams();
  const [memberData, setMemberData] = useState({});
  // const contributionData = useSelector((state) => state.updateContribution);
  const { selectedContribution } = useSelector(
    (state) => state.updateContribution,
  );
  const { userData } = useSelector((state) => state?.user);
  const [memberUpdateData, setMemberUpdateData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentOrders, setPaymentOrders] = useState({});
  const [paymentData, setData] = useState([]);
  // const [paymentMethods, setPaymentMethods] = useState([]);
  const paymentMethods = [
    { name: "CARD", value: "CARD" },
    { name: "NET BANKING", value: "NET_BANKING" },
    { name: "WALLET", value: "WALLET" },
    { name: "UPI", value: "UPI" },
    { name: "CASH", value: "CASH" },
    { name: "CHEQUE", value: "CHEQUE" },
    { name: "DEMAND DRAFT", value: "DEMAND_DRAFT" },
  ];
  const uinType = [
    { name: "PAN CARD", value: "PAN_CARD" },
    { name: "AADHAR CARD", value: "AADHAR_CARD" },
    { name: "VOTER CARD", value: "VOTER_CARD" },
    { name: "DRIVING LICENSE", value: "DRIVING_LICENSE" },
    { name: "PASSPORT", value: "PASSPORT" },
  ];
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    selectedContribution?.paymentTransaction?.paymentMethodType,
  );
  // const [uinType, setUinType] = useState([]);
  const [selectedUinType, setSelectedUinType] = useState(
    selectedContribution?.uinType,
  );
  const [payableCity, setPayableCity] = useState([]);
  const [selectedPayableCity, setSelectedPayableCity] = useState(
    selectedContribution?.payableCityId,
  );
  const [selectedDate, setSelectedDate] = useState(
    dayjs(selectedContribution?.paymentTransaction?.chequeDate) ??
      dayjs(selectedContribution?.paymentTransaction?.ddDate) ??
      null,
  );
  const [dishonouredDate, setDishonouredDate] = useState(
    dayjs(selectedContribution?.paymentTransaction?.dishonourDate) ?? null,
  );
  const [cancalationDate, setCancalationDate] = useState(
    selectedContribution?.paymentTransaction?.receiptCancelDate,
  );
  const [states, setStates] = useState([]);
  const [stateVal, setStateVal] = useState(Number(userData?.state));
  const [cities, setCities] = useState([]);
  const [cityVal, setCityVal] = useState(Number(userData?.city));
  const [isReceiptCancelled, setIsReceiptCancelled] = useState(
    selectedContribution?.paymentTransaction?.receiptCancelledFlag,
  );
  const [disableReceiptCancelled, setDisableReceiptCancelled] = useState(
    selectedContribution?.paymentTransaction?.receiptCancelledFlag,
  );
  const [isDishonouredCheque, setIsDishonouredCheque] = useState(false);
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [selectedReceiptType, setSelectedReceiptType] = useState(
    selectedContribution?.donationPurpose,
  );
  const [bankTypes, setBankTypes] = useState([]);
  const [selectedBankType, setSelectedBankType] = useState(
    selectedContribution?.paymentTransaction?.drawnBankId,
  );
  const [amountValue, setAmountValue] = useState(selectedContribution?.amount);
  const [uinValue, setUinValue] = useState(selectedContribution?.uin);
  const [chequeDDNo, setChequeDDNo] = useState(
    selectedContribution?.paymentTransaction?.chequeNumber ??
      selectedContribution?.paymentTransaction?.ddNumber ??
      null,
  );
  const [memberNameValue, setMemberNameValue] = useState(userData?.fullName);
  const [mobileNumber, setMobileNumber] = useState(userData?.mobileNumber);
  const [otherBank, setOtherBank] = useState(
    selectedContribution?.paymentTransaction?.otherBankName ?? "",
  );
  const [dishonouredReason, setdishonouredReason] = useState(
    selectedContribution?.paymentTransaction?.dishonourReason,
  );
  const [cancellationReason, setCancelationReason] = useState(
    selectedContribution?.paymentTransaction?.receiptCancelReason,
  );
  const [startMinDate, setStartDate] = useState(
    dayjs(selectedContribution?.createdAt),
  );
  const today = new Date();
  const threeDaysLater = new Date();
  threeDaysLater.setDate(today.getDate() + 2);
  const navigate = useNavigate();
  const toast = useContext(ToastAlertContext);
  const [receiptNo, setReceiptNo] = useState(
    selectedContribution?.paymentTransaction?.externalReceiptNumber,
  );
  const handleDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedDate(formattedDate);
  };
  const handleDishonouredDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setDishonouredDate(formattedDate);
  };
  const handleCancalationDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setCancalationDate(formattedDate);
  };
  // const handleMemberName = (value) => {
  //   console.log("New Member Name:", value);
  //   setMemberNameValue(value);
  // };
  const handleAmountChange = (value) => {
    setAmountValue(value);
  };
  const handleUinValue = (value) => {
    setUinValue(value);
  };
  const handleChequeDDNo = (value) => {
    setChequeDDNo(value);
  };
  const handleMemberName = (value) => {
    setMemberNameValue(value);
  };
  const handleMobileNumber = (value) => {
    setMobileNumber(value);
  };
  const handleOtherBanks = (value) => {
    setOtherBank(value);
  };
  const handleDishonouredReason = (value) => {
    setdishonouredReason(value);
  };
  const getUserProfile = async () => {
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_MEMBER}/${memberId}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberData(data.data);
        setMemberUpdateData(data.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } else {
        console.error("Failed to fetch Division Type data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const getMemberUinOnChange = async (uinType) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        const selectedUinEntry = data.data.find(
          (entry) => entry.uinType === uinType,
        );
        // console.log("line 162", selectedUinEntry);
        if (selectedUinEntry) {
          setUinValue(selectedUinEntry?.uin);
          setSelectedUinType(selectedUinEntry?.uinType);
        } else {
          setUinValue("");
          console.error("No data found for the selected UIN type");
        }
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // const handlePaymentMethod = async () => {
  //   try {
  //     const url = `${SERVICES.PAYMENT_METHODS}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setPaymentMethods(data.data);
  //     }
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };
  // const handleUinType = async () => {
  //   try {
  //     const url = `${SERVICES.UIN_TYPES}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setUinType(data.data);
  //     }
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };
  const handlePayableCity = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYABLE_CITIES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setPayableCity(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleReceiptTypes = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setReceiptTypes(data.data.receiptTypes);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getPaymentOrders = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders?size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setPaymentOrders(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleBankTypes = async () => {
    try {
      const url = `${SERVICES.GET_BSG_BANKS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setBankTypes(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleStates = async () => {
    try {
      const url = `${MasterDataServices.GET_STATES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setStates(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleCities = async () => {
    try {
      if (stateVal !== "") {
        const url = `${MasterDataServices.GET_STATES}/${stateVal}/cities`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setCities(data.data);
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  // const handleStateChange = (selectedValue) => {
  //   setStateVal(selectedValue?.value);
  //   // onDetailsChange((prevValues) => ({
  //   //   ...prevValues,
  //   //   stateId: selectedValue?.value,
  //   // }));
  // };
  const handleStateChange = (selectedValue) => {
    if (selectedValue) {
      setStateVal(selectedValue?.value);
    } else {
      setStateVal("");
      setCityVal("");
    }
  };

  const handleCityChange = (selectedValue) => {
    setCityVal(selectedValue?.value);
    // onDetailsChange((prevValues) => ({
    //   ...prevValues,
    //   cityId: selectedValue?.value,
    // }));
  };
  const validateContributionDetails = () => {
    if (!selectedPaymentMethod) {
      toast.show("Please Select Payment Method", AlertStatus.ERROR);
      return false;
    }
    if (!amountValue) {
      toast.show("Please Select Amount", AlertStatus.ERROR);
      return false;
    }
    if (!selectedUinType) {
      toast.show("Please Select Uin Type", AlertStatus.ERROR);
      return false;
    }
    if (
      selectedUinType === "PAN_CARD" &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid PAN.\nFor Example: XXXXX9999X`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "AADHAR_CARD" &&
      !/^[2-9]{1}[0-9]{11}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Aadhaar Number.\nFor Example 999999999999`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "VOTER_CARD" &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Elector's Photo Identity Number.`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "DRIVING_LICENSE" &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Driving License Number.`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "PASSPORT" &&
      !/^[A-Z]{1}[0-9]{7}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Passport Number.\nFor Example JXXXXXXX`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (!selectedReceiptType) {
      toast.show("Please Select Donation Purpose", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !chequeDDNo
    ) {
      toast.show("Please Select Cheque/DD No.", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !selectedDate
    ) {
      toast.show("Please Select Date", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !selectedPayableCity
    ) {
      toast.show("Please Select Payable City", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !selectedBankType
    ) {
      toast.show("Please Select Drawn on Bank", AlertStatus.ERROR);
      return false;
    }
    if (selectedBankType === 6 && !otherBank) {
      toast.show("Please Enter Other Bank", AlertStatus.ERROR);
      return false;
    }
    if (isDishonouredCheque && !dayjs(dishonouredDate).isValid()) {
      toast.show("Please Select a Valid Dishonoured Date", AlertStatus.ERROR);
      return false;
    }
    if (isDishonouredCheque && !dishonouredReason) {
      toast.show("Please Select Dishonoured Reason", AlertStatus.ERROR);
      return false;
    }
    if (isReceiptCancelled && !dayjs(cancalationDate).isValid()) {
      toast.show("Please Select a Valid Cancelleation Date", AlertStatus.ERROR);
      return false;
    }
    if (isReceiptCancelled && !cancellationReason) {
      toast.show("Please Select Cancellation Reason", AlertStatus.ERROR);
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (!validateContributionDetails()) {
      return;
    }
    const formattedDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
    const data = {
      id: selectedContribution.id,
      orderId: selectedContribution.orderId,
      fullName: memberData.fullName,
      orderPaymentMethod:
        selectedPaymentMethod === "CARD" ||
        selectedPaymentMethod === "NET_BANKING" ||
        selectedPaymentMethod === "WALLET" ||
        selectedPaymentMethod === "UPI"
          ? "PAYMENT_GATEWAY"
          : selectedPaymentMethod,
      amount: Number(amountValue),
      uinType: selectedUinType,
      uin: uinValue,
      type: "ONE_TIME",
      status: isReceiptCancelled ? "CANCELLED" : "SUCCESS",
      source: "WEB",
      cityName: null,
      // receiptFileUrl: null,
      createdAt: formattedDate,
      paymentTransaction: {
        id: selectedContribution.paymentTransaction.id,
        amount: Number(amountValue),
        paymentMethodType: selectedPaymentMethod,
        paymentGateway: null,
        status: "CAPTURED",
        cardLast4Digits: null,
        upiVpa: null,
        createdAt: formattedDate,
        chequeDate: selectedPaymentMethod === "CHEQUE" ? selectedDate : null,
        receiptNumber: null,
        receiptDate: null,
        chequeNumber: selectedPaymentMethod === "CHEQUE" ? chequeDDNo : null,
        ddDate: selectedPaymentMethod === "DEMAND_DRAFT" ? selectedDate : null,
        ddNumber: selectedPaymentMethod === "DEMAND_DRAFT" ? chequeDDNo : null,
        otherBankName: otherBank || null,
        drawnBankId: selectedBankType || null,
        dishonoured: null,
        dishonourDate: dishonouredDate || null,
        dishonourReason: dishonouredReason || null,
        receiptCancelledFlag: isReceiptCancelled,
        receiptCancelDate: cancalationDate || null,
        receiptCancelReason: cancellationReason,
      },
      donationPurpose: selectedReceiptType,
      payableCityId: selectedPayableCity || null,
      payableCityName: null,
      bankId: null,
      bankName: null,
      createdBy: memberId,
      updatedBy: memberId,
    };
    const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders`;
    try {
      const response = await put(url, data);
      if (response.ok) {
        const res = await response.json();
        toast.show("Details Updated Successfully", AlertStatus.SUCCESS);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } else {
        const errorData = await response.json();
        toast.show(errorData.message, AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    if (paymentOrders.content) {
      const updatedTableData = paymentOrders.content.map((item) => {
        const formattedDate = moment(item?.createdAt).format("DD/MM/YYYY");
        return {
          "Mode of Payment":
            item?.paymentTransaction?.paymentMethodType?.replace(/_/g, " "),
          Amount: item?.amount ? `${item.amount.toString()}.00` : "",
          "Contrubution Date": formattedDate,
          "payment Status": item?.status,
          "Uin Types": item?.uinType?.replace(/_/g, " "),
        };
      });

      setData(updatedTableData);
    }
  }, [paymentOrders.content]);
  useEffect(() => {
    getUserProfile();
    getPaymentOrders();
    // handlePaymentMethod();
    // handleUinType();
    handlePayableCity();
    handleReceiptTypes();
    handleBankTypes();
  }, [memberId]);
  useEffect(() => {
    handleStates();
    handleCities();
  }, [stateVal]);
  // console.log(selectedContribution);
  // console.log("userData", userData);
  // console.log(stateVal);
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <PageSyncCal />
      <Heading title="Update Contribution Details" />
      <OuterContainerStyles
        marginTop="24px"
        marginBottom="24px"
        style={{ padding: "24px" }}
      >
        <OuterCard>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Organization Structure
          </OuterCardHeading>
          <OuterCardText>
            {`${memberData.areaName || "NA"} / 
            ${memberData.clusterName || "NA"} /${
              memberData.zoneName || "NA"
            } / ${memberData.regionName || "NA"} / ${
              memberData.chapterName || "NA"
            } / ${memberData.districtName || "NA"} / ${
              memberData.blockName || "NA"
            }`}
          </OuterCardText>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Member Details
          </OuterCardHeading>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>Member Name</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData.fullName}</MemberDetailsText>
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>Address</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData.addressLine1}</MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv>
            <MemberDetailsTextHeading>Contact Info</MemberDetailsTextHeading>
            <MemberDetailsText>
              {`${memberData.emailId}  /  ${memberData.mobileNumber}`}
            </MemberDetailsText>
          </MemberDetailsDiv>
          {/* <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>Gohonzon Member</MemberDetailsTextHeading>
            <MemberDetailsText>
              {" "}
              {memberData.gohonzonMemberships &&
              memberData.gohonzonMemberships.length > 0
                ? memberData.gohonzonMemberships[0].type
                : "No"}
            </MemberDetailsText>
          </MemberDetailsDiv2> */}
          <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>
              Division/Sub Division
            </MemberDetailsTextHeading>
            <MemberDetailsText> {memberData?.divisionName}</MemberDetailsText>
          </MemberDetailsDiv2>
          {/* <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              Contribution Collection to Deposit
            </MemberDetailsTextHeading>
            <MemberDetailsText>Yes Bank</MemberDetailsText>
          </MemberDetailsDiv> */}
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Contribution Details
          </OuterCardHeading>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptions(paymentMethods, "value")}
              label="Payment Method"
              name="paymentMethods"
              value={selectedPaymentMethod}
              onChange={(selectedValue) => {
                setSelectedPaymentMethod(selectedValue?.value);
              }}
              inputProps={{
                required: true,
              }}
              disabled={
                selectedPaymentMethod === "CARD" ||
                selectedPaymentMethod === "NET_BANKING" ||
                selectedPaymentMethod === "WALLET" ||
                selectedPaymentMethod === "UPI"
              }
              useHiddenInput
              style={{ width: "350px" }}
            />
            <InputField
              label="Amount"
              name="amount"
              required
              value={amountValue}
              // onChange={(event) => {
              //   const { value } = event.target;
              //   onAmountChange(value);
              // }}
              onChange={(event) => {
                const { value } = event.target;
                handleAmountChange(value);
              }}
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptionsForUin(uinType, "value")}
              label="Uin Type"
              name="uinType"
              value={selectedUinType}
              onChange={(selectedValue) => {
                setSelectedUinType(selectedValue?.value);
                getMemberUinOnChange(selectedValue?.value);
              }}
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <InputField
              label="Uin No."
              name="amount"
              value={uinValue}
              // onChange={(event) => {
              //   const { value } = event.target;
              //   onAmountChange(value);
              // }}
              onChange={(event) => {
                const { value } = event.target;
                handleUinValue(value);
              }}
              required
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptions(receiptTypes, "id")}
              label="Donation Purpose"
              name="receiptTypes"
              value={selectedReceiptType}
              onChange={(selectedValue) => {
                setSelectedReceiptType(selectedValue?.value);
              }}
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
              disabled
            />
            <TextField
              id="outlined-multiline-static"
              label="Remarks"
              multiline
              rows={2}
              // defaultValue="Default Value"
              sx={{ width: "350px", backgroundColor: "white" }}
            />
          </FieldsDiv>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Cheque / DD Details (if any)
          </OuterCardHeading>
          <FieldsDiv>
            <InputField
              label="Cheque/DD No."
              name="amount"
              // onChange={(event) => {
              //   const { value } = event.target;
              //   onAmountChange(value);
              // }}
              inputProps={{
                maxLength: 6,
              }}
              value={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
                  ? ""
                  : chequeDDNo
              }
              onChange={(event) => {
                const { value } = event.target;
                handleChequeDDNo(value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              style={{ width: "350px" }}
              required
            />
            <BasicDatePicker
              // useDefaultBorders
              label="Cheque/DD Date"
              sx={{
                width: "350px",
                backgroundColor:
                  selectedPaymentMethod !== "CHEQUE" &&
                  selectedPaymentMethod !== "DEMAND_DRAFT"
                    ? "rgba(239, 239, 239, 1.5)"
                    : "white",
              }}
              value={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
                  ? null
                  : selectedDate
              }
              onChange={handleDateChange}
              maxDate={dayjs(threeDaysLater)}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              required
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              options={getOptions(payableCity, "id")}
              label="Payable City"
              name="payableCity"
              value={selectedPayableCity}
              onChange={(selectedValue) => {
                setSelectedPayableCity(selectedValue?.value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.bankName}
              options={getOptions(bankTypes, "id")}
              label="Drawn on Bank"
              name="paymentMethods"
              // value={selectedPaymentMethod}
              value={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
                  ? ""
                  : selectedBankType
              }
              onChange={(selectedValue) => {
                setSelectedBankType(selectedValue?.value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <InputField
              label="Other Bank"
              // name="amount"
              onChange={(event) => {
                const { value } = event.target;
                handleOtherBanks(value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              style={{ width: "350px" }}
              required={selectedBankType === 6}
            />
            <BasicDatePicker
              // useDefaultBorders
              label="Dishonoured Date"
              sx={{
                width: "350px",
                backgroundColor:
                  selectedPaymentMethod !== "CHEQUE" &&
                  selectedPaymentMethod !== "DEMAND_DRAFT"
                    ? "rgba(239, 239, 239, 1.5)"
                    : "white",
              }}
              value={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
                  ? null
                  : dishonouredDate
              }
              onChange={handleDishonouredDateChange}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              required={isDishonouredCheque}
            />
          </FieldsDiv>
          <FieldsDiv>
            <Box sx={{ width: "350px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={
                      selectedPaymentMethod !== "CHEQUE" &&
                      selectedPaymentMethod !== "DEMAND_DRAFT"
                    }
                    checked={isDishonouredCheque}
                    onChange={(event) =>
                      setIsDishonouredCheque(event.target.checked)
                    }
                  />
                }
                label="Dishonoured Cheques"
              />
            </Box>
            <InputField
              label="Dishonoured Reason"
              name="amount"
              // onChange={(event) => {
              //   const { value } = event.target;
              //   onAmountChange(value);
              // }}
              value={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
                  ? ""
                  : dishonouredReason
              }
              onChange={(event) => {
                const { value } = event.target;
                handleDishonouredReason(value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              style={{ width: "350px" }}
              required={isDishonouredCheque}
            />
          </FieldsDiv>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Receipt Cancellation Details
          </OuterCardHeading>
          <FieldsDiv>
            <InputField
              label="Receipt No."
              name="amount"
              InputProps={{
                readOnly: true,
              }}
              disabled
              value={receiptNo}
              style={{ width: "350px" }}
            />
            <Box sx={{ width: "350px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isReceiptCancelled}
                    onChange={(event) =>
                      setIsReceiptCancelled(event.target.checked)
                    }
                    disabled={disableReceiptCancelled}
                  />
                }
                label="Cancel Receipt"
              />
            </Box>
          </FieldsDiv>
          <FieldsDiv>
            <BasicDatePicker
              // useDefaultBorders
              label="Cancellation Date"
              value={dayjs(cancalationDate)}
              minDate={startMinDate}
              sx={{
                width: "350px",
                backgroundColor:
                  // selectedPaymentMethod !== "CHEQUE" &&
                  // selectedPaymentMethod !== "DEMAND_DRAFT"
                  //   ? "rgba(239, 239, 239, 1.5)"
                  //   : "white",
                  !isReceiptCancelled ? "rgba(239, 239, 239, 1.5)" : "white",
              }}
              onChange={handleCancalationDateChange}
              disabled={!isReceiptCancelled || disableReceiptCancelled}
              required={isReceiptCancelled}
            />
            <TextField
              id="outlined-multiline-static"
              label="Reason"
              multiline
              rows={2}
              // defaultValue="Default Value"
              disabled={!isReceiptCancelled || disableReceiptCancelled}
              onChange={(e) => setCancelationReason(e.target.value)}
              value={cancellationReason}
              sx={{
                width: "350px",
                backgroundColor: !isReceiptCancelled
                  ? "rgba(239, 239, 239, 1.5)"
                  : "white",
                "& .MuiInputLabel-asterisk": {
                  color: "red",
                },
              }}
              required={isReceiptCancelled}
            />
          </FieldsDiv>
        </OuterCard>
        {/* <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Update Member Name & Address for Contribution
          </OuterCardHeading>
          <MemberCardText>
            (Member updates for contribution data only)
          </MemberCardText>
          <FieldsDiv>
            <InputField
              label="Member Name"
              name={UPDATE_FIELDS.UPDATE_MEMBER_NAME}
              type="text"
              value={memberNameValue}
              onChange={(event) => {
                handleMemberName(event.target.value);
              }}
              style={{ width: "350px" }}
            />
            <InputField
              label="Mobile Number"
              name="mobileNumber"
              type="text"
              value={mobileNumber}
              inputProps={{
                maxLength: 10,
              }}
              style={{ width: "350px" }}
              onChange={(event) => {
                const { value } = event.target;
                handleMobileNumber(value);
              }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.stateName}
              label="State"
              name="stateId"
              options={getOptions(states, "stateId")}
              value={stateVal}
              inputProps={{ required: false }}
              onChange={handleStateChange}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              label="City"
              name="cityId"
              options={getOptions(cities, "cityId")}
              value={cityVal}
              disabled={!stateVal}
              inputProps={{ required: false }}
              onChange={handleCityChange}
              useHiddenInput
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <InputField
              label="Pin Code"
              name="pincode"
              type="text"
              inputProps={{
                maxLength: 10,
              }}
              style={{ width: "350px" }}
            />
            <TextField
              id="outlined-multiline-static"
              label="Address"
              multiline
              rows={2}
              defaultValue={userData?.addressLine1}
              sx={{ width: "350px", backgroundColor: "white" }}
            />
          </FieldsDiv>
        </OuterCard> */}
        {/* <Footer>
          <FooterText>
            Please check for correctness of Contributor’s name. In case of any
            correction DO NOT PROCEED. Please contact your Region Stats Incharge
            for correction in Name.If you proceed, name correction cannot be
            done in this Financial Year.
          </FooterText>
        </Footer> */}
        <ButtonContainer>
          <Button cancel onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button onClick={handleSubmit}>Submit</Button>
        </ButtonContainer>
      </OuterContainerStyles>
      {isLoading && <Loader />}
    </div>
  );
}

export default MemberContributionUpdate;

const OuterCard = styled.div`
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c5c5d1;
  background: #f5f5f5;
`;

const OuterCardHeading = styled.p`
  margin: 0;
  color: #000;
  //   font-family: Noto Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const OuterCardText = styled.p`
  margin: 0;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
// const MemberDetailsDiv = styled.div`
//   display: flex;
//   // padding: 7px 24px;
//   padding: 16px 24px;
//   align-items: center;
//   gap: 8px;
//   align-self: stretch;
//   border: 1px solid #62b6da;
//   background: #fff;
// `;
const MemberDetailsDiv = styled.div`
  display: flex;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #fff;
`;
const MemberDetailsDiv2 = styled.div`
  display: flex;
  padding: 7px 24px;
  // padding: 16px 24px;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #e8f6fc;
`;
const MemberDetailsTextHeading = styled.p`
  margin: 0;
  width: 250px;
  color: #484848;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
const MemberDetailsText = styled.p`
  margin: 0;
  width: 270px;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;
const FieldsDiv = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 146px;
  align-self: stretch;
`;

const Footer = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const FooterText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: 24px 30px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
const NodataText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;

const MemberCardText = styled.p`
  margin: 0;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
